import React from "react";

const Cards = () => {
  return (
    <div className="py-[50px]">
      <h1 className="text-2xl font-bold text-center mb-4">Pricing</h1>
      <div className="max-w-[1200px] mx-auto grid grid-cols-1 md:grid-cols-4 md:gap-6 justify-center">
        <div className="shadow-xl h-[300px] md:h-[400px] bg-slate-200 hover:scale-110 duration-300 md:mx-0 mx-4 my-4">
          <h1 className=" text-center text-2xl pt-8">Ethical Hacking</h1>
          <h1 className=" text-center text-2xl pt-8">$150</h1>
          <p className="text-center px-2 md:pt-8">
            Lorem ipsum dolor amet. Id placeat ipsa et veniam omnis et aliquam
            quis sed illo
          </p>
          <button className="bg-black mx-[100px] md:mx-14 text-white p-3 rounded-md w-[160px] mt-4">
            Start Trial
          </button>
        </div>
        <div className="shadow-xl h-[300px] md:h-[400px] bg-slate-200 hover:scale-110 duration-300 md:mx-0 mx-4 my-4">
          <h1 className=" text-center text-2xl pt-8">Ethical Hacking</h1>
          <h1 className=" text-center text-2xl pt-8">$150</h1>
          <p className="text-center px-2 md:pt-8">
            Lorem ipsum dolor amet. Id placeat ipsa et veniam omnis et aliquam
            quis sed illo
          </p>
          <button className="bg-black mx-[100px] md:mx-14 text-white p-3 rounded-md w-[160px] mt-4">
            Start Trial
          </button>
        </div>
        <div className="shadow-xl h-[300px] md:h-[400px] bg-slate-200 hover:scale-110 duration-300 md:mx-0 mx-4 my-4">
          <h1 className=" text-center text-2xl pt-8">Ethical Hacking</h1>
          <h1 className=" text-center text-2xl pt-8">$150</h1>
          <p className="text-center px-2 md:pt-8">
            Lorem ipsum dolor amet. Id placeat ipsa et veniam omnis et aliquam
            quis sed illo
          </p>
          <button className="bg-black mx-[100px] md:mx-14 text-white p-3 rounded-md w-[160px] mt-4">
            Start Trial
          </button>
        </div>
        <div className="shadow-xl h-[300px] md:h-[400px] bg-slate-200 hover:scale-110 duration-300 md:mx-0 mx-4 my-4">
          <h1 className=" text-center text-2xl pt-8">Ethical Hacking</h1>
          <h1 className=" text-center text-2xl pt-8">$150</h1>
          <p className="text-center px-2 md:pt-8">
            Lorem ipsum dolor amet. Id placeat ipsa et veniam omnis et aliquam
            quis sed illo
          </p>
          <button className="bg-black mx-[100px] md:mx-14 text-white p-3 rounded-md w-[160px] mt-4">
            Start Trial
          </button>
        </div>
      </div>
    </div>
  );
};

export default Cards;
